import { useMemo } from "react";
import { queriesInternalAccounts, queriesTaxWithholdings } from "@query";
import { selectorIsTaxWithholdingsSetupComplete } from "../selectors/selectorIsTaxWithholdingsSetupComplete";

export function useIsTaxWithholdingsSetupComplete() {
  const querySettings =
    queriesTaxWithholdings.getTaxWithholdingSettings.useQuery();
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();

  return useMemo(
    () =>
      selectorIsTaxWithholdingsSetupComplete({
        withholdingRate: querySettings.data?.withholdingRate,
        internalAccounts: queryInternalAccounts.data?.data
      }),
    [querySettings.data, queryInternalAccounts.data]
  );
}
